<template>
  <campsite-detail-search-breadcrumbs v-bind="locationBreadcrumbsProps" />
  <div class="location-row">
    <campsite-map-modal ref="mapModal" :campsite="campsite">
      <template #card>
        <campsite-map-card
          :campsite="mapCampsite"
          :is-dated="isDated"
          :show-price="!isDated"
        >
          <template #footer>
            <campsite-map-card-button
              :available-to-search="campsite.availableToSearch"
              :hierarchy-path="campsite.path"
              :slug="campsite.slug"
              :is-bookable="campsite.isBookable"
              :is-dated="isDated"
              :has-availability="hasAvailability"
              @click="closeMapModalAndScrollToPitchTypes"
            />
          </template>
        </campsite-map-card>
      </template>
    </campsite-map-modal>
  </div>
</template>
<script lang="ts">
import {
  Component,
  Prop,
  Ref,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'
import { campsiteToMapCampsite } from '../../campsites/maps'
import { MapCampsite } from '../../maps/domain/MapsCampsite'
import { CampsiteDetails } from '../types'
import { CampsiteDetailLocationRowProps } from './CampsiteDetailLocationRowProps'
import CampsiteDetailSearchBreadcrumbs from './CampsiteDetailSearchBreadcrumbs.vue'

@Component({
  components: {
    CampsiteDetailSearchBreadcrumbs,
  },
})
class CampsiteDetailLocationRow
  extends Vue
  implements CampsiteDetailLocationRowProps
{
  @Prop({ required: true })
  campsite: CampsiteDetails

  @Prop({ required: true })
  isDated: boolean

  @Prop({ required: true })
  hasAvailability: boolean

  get locationBreadcrumbsProps() {
    // TODO: Add hierarchyBreadcrumbs to CampsiteDetails type instead of using any
    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy campsite type missing hierarchyBreadcrumbs
      hierarchyBreadcrumbs: (this.campsite as any).hierarchyBreadcrumbs,
      countryIso: this.campsite.countryIso,
    }
  }

  @Ref()
  private readonly mapModal?: CampsiteMapModal

  closeMapModalAndScrollToPitchTypes() {
    if (this.mapModal) {
      // TODO: Add proper types for mapModal methods
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.mapModal.closeModal()
      this.isDated && this.scrollToPitchTypes()
    }
  }

  private scrollToPitchTypes() {
    this.$puScrollTo('[data-pitchtypes-scroll-target]', { duration: 150 })
  }

  get mapCampsite(): MapCampsite {
    return campsiteToMapCampsite(this.campsite)
  }
}

export default toNative(CampsiteDetailLocationRow)
</script>

<style scoped>
.location-row {
  float: right;
  margin-top: 0.65em;
}
</style>
